import React from "react";
import { useTranslation } from "react-i18next";
import {
  HiOutlineViewBoards,
  HiOutlineClipboardList,
  HiOutlineUsers,
  HiOutlineTag,
  HiOutlineCalendar,
} from "react-icons/hi";
import GettingStarted from "../../../molecules/GettingStarted";

const TodosGettingStarted: React.FC = () => {
  const { t } = useTranslation();

  const steps = [
    {
      icon: <HiOutlineClipboardList size={22} />,
      title: t("todos.gettingStarted.steps.step1.title") as string,
      body: t("todos.gettingStarted.steps.step1.body") as string,
      mockup: (
        <div className="mt-3 bg-white border border-gray-200 rounded-md p-3 overflow-hidden">
          <div className="flex items-center gap-4 text-xs font-semibold text-gray-900">
            <span>{t("todos.gettingStarted.steps.step1.colTodo")}</span>
            <span>{t("todos.gettingStarted.steps.step1.colDoing")}</span>
            <span>{t("todos.gettingStarted.steps.step1.colDone")}</span>
          </div>
        </div>
      ),
      tip: t("todos.gettingStarted.steps.step1.tip") as string,
    },
    {
      icon: <HiOutlineTag size={22} />,
      title: t("todos.gettingStarted.steps.step2.title") as string,
      body: t("todos.gettingStarted.steps.step2.body") as string,
      mockup: (
        <div className="mt-3 bg-white border border-gray-200 rounded-md p-3 overflow-hidden">
          <div className="flex items-center flex-wrap gap-1.5">
            <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-red-50 text-red-700 border border-red-200 text-xs font-medium">
              <HiOutlineTag size={10} />
              {t("todos.gettingStarted.steps.step2.badgeUrgent")}
            </span>
            <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-blue-50 text-blue-700 border border-blue-200 text-xs font-medium">
              <HiOutlineTag size={10} />
              {t("todos.gettingStarted.steps.step2.badgeClient")}
            </span>
            <span className="inline-flex items-center gap-1 text-xs text-gray-500">
              <HiOutlineCalendar size={11} />
              {t("todos.gettingStarted.steps.step2.due")}
            </span>
          </div>
        </div>
      ),
    },
    {
      icon: <HiOutlineUsers size={22} />,
      title: t("todos.gettingStarted.steps.step3.title") as string,
      body: t("todos.gettingStarted.steps.step3.body") as string,
      mockup: (
        <div className="mt-3 bg-white border border-gray-200 rounded-md p-3 overflow-hidden">
          <div className="flex items-center gap-1.5">
            <span className="w-6 h-6 rounded-full bg-gray-100 text-gray-600 text-xs font-semibold flex items-center justify-center">
              AB
            </span>
            <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-blue-50 border border-blue-200 text-blue-700 text-xs font-medium">
              {t("todos.gettingStarted.steps.step3.teamTag")}
            </span>
            <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-gray-50 border border-gray-200 text-gray-600 text-xs font-medium">
              {t("todos.gettingStarted.steps.step3.groupTag")}
            </span>
          </div>
        </div>
      ),
      tip: t("todos.gettingStarted.steps.step3.tip") as string,
    },
  ];

  return (
    <GettingStarted
      icon={<HiOutlineViewBoards className="w-6 h-6 sm:w-7 sm:h-7" />}
      title={t("todos.gettingStarted.title") as string}
      subtitle={t("todos.gettingStarted.subtitle") as string}
      steps={steps}
    />
  );
};

export default TodosGettingStarted;
